import { Dialog, DialogPortal } from '@/components/ui/dialog'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { Button } from '@/components/ui/button'
import { X } from 'lucide-react'
import { cn } from '@/lib/utils'

interface OffPlatformWarningDialogProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  onCancel: () => void
}

export function OffPlatformWarningDialog({
  isOpen,
  onOpenChange,
  onConfirm,
  onCancel
}: OffPlatformWarningDialogProps) {
  const handleCancel = () => {
    onCancel()
    onOpenChange(false)
  }

  const handleConfirm = () => {
    onConfirm()
    onOpenChange(false)
  }

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogPrimitive.Overlay
          className={cn(
            "fixed inset-0 z-[60] bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
          )}
        />
        <DialogPrimitive.Content
          className={cn(
            "fixed left-0 right-0 top-[50%] z-[60] translate-y-[-50%] border-none bg-background shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-top-[48%] rounded-[var(--card-radius)] max-h-[90vh] p-0 overflow-hidden mx-auto",
            "max-w-[calc(var(--max-content-width)+var(--min-side-padding)*2)]"
          )}
        >
          {/* Header */}
          <div className="flex items-center justify-between p-6 pb-4">
            <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
              Leaving the platform?🤔
            </h2>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleCancel()}
              className="p-2 -mr-2"
            >
              <X className="h-5 w-5" />
              <span className="sr-only">Close</span>
            </Button>
          </div>

          {/* Content */}
          <div className="px-6 pb-6">
            <div className="space-y-4">
              {/* Main message */}
              <div className="space-y-3">
                <p className="text-sm text-foreground leading-relaxed">
                  There were possibly references to other messaging platforms in your message and would want to quickly remind that it is against our Terms of Service to take converstations off the platform.
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col items-center gap-3 pt-4">
                <Button
                  onClick={handleCancel}
                  className="w-full px-8 py-6 text-base font-medium rounded-[var(--card-radius)]"
                  size="lg"
                >
                  Cancel Send
                </Button>
                <div className="w-full border border-input rounded-[var(--card-radius)]">
                  <Button
                    variant="outline"
                    onClick={handleConfirm}
                    className="w-full px-8 py-6 text-base font-medium rounded-[var(--card-radius)] border-0"
                    size="lg"
                  >
                    I'm not - Send Anyway
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>
  )
}

